import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { FooterComponent } from '../shared/components/new-footer/footer.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { PhoneNegativeIconComponent } from '../shared/components/icons/generated/phone-negative/phone-negative.component';
import { MailIconComponent } from '../shared/components/icons/generated/mail/mail.component';
import { PopsyDuoIconComponent } from '../shared/components/icons/generated/popsy-duo/popsy-duo.component';
import { TalkIconComponent } from '../shared/components/icons/generated/talk/talk.component';
import { FastTruckIconComponent } from '../shared/components/icons/generated/fast-truck/fast-truck.component';
import { OkBagIconComponent } from '../shared/components/icons/generated/ok-bag/ok-bag.component';
import { StarFilledIconComponent } from '../shared/components/icons/generated/star-filled/star-filled.component';
import { BuzzfeedIconComponent } from '../shared/components/icons/generated/buzzfeed/buzzfeed.component';
import { InsiderIconComponent } from '../shared/components/icons/generated/insider/insider.component';
import { ForbesIconComponent } from '../shared/components/icons/generated/forbes/forbes.component';
import { ShippingBoxIconComponent } from '../shared/components/icons/generated/shipping-box/shipping-box.component';
import { VisitIconComponent } from '../shared/components/icons/generated/visit/visit.component';
import { PercentIconComponent } from '../shared/components/icons/generated/percent/percent.component';
import { StatsIconComponent } from '../shared/components/icons/generated/stats/stats.component';
import { GlobeIconComponent } from '../shared/components/icons/generated/globe/globe.component';
import { PinIconComponent } from '../shared/components/icons/generated/pin/pin.component';
import { LogoColorIconComponent } from '../shared/components/icons/generated/logo-color/logo-color.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-suppliers-page',
  templateUrl: './suppliers-page.template.html',
  styleUrls: ['./suppliers-page.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    LogoColorIconComponent,
    PinIconComponent,
    GlobeIconComponent,
    StatsIconComponent,
    PercentIconComponent,
    VisitIconComponent,
    ShippingBoxIconComponent,
    ForbesIconComponent,
    InsiderIconComponent,
    BuzzfeedIconComponent,
    StarFilledIconComponent,
    OkBagIconComponent,
    FastTruckIconComponent,
    TalkIconComponent,
    PopsyDuoIconComponent,
    MailIconComponent,
    PhoneNegativeIconComponent,
    NgIf,
    FooterComponent,
    AsyncPipe,
  ],
})
export class SuppliersPageComponent implements OnDestroy {
  public isBrowser: boolean;

  public lessThan$: Observable<ScreenSizeInfoState>;
  public inFullScreenMode$: Observable<boolean>;

  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.destroySubject = new Subject();
    this.isBrowser = this.akitaRouterQuery.isBrowser;
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.inFullScreenMode$ = this.akitaRouterQuery.selectInFullScreenMode();
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
